var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackEmoji1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9869,
    cy: 37.9869,
    r: 36.5972,
    stroke: "#27ABB3",
    strokeWidth: 2.77953
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9194 24.0895L29.1845 28.722H18.0664",
    stroke: "#27ABB3",
    strokeWidth: 2.77953
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6665 24.0895L45.4014 28.722H56.5195",
    stroke: "#27ABB3",
    strokeWidth: 2.77953
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1065 51.8847H25.4805C26.2526 47.561 29.3718 38.9136 37.5251 38.9136C45.6784 38.9136 48.6432 47.561 49.1065 51.8847Z",
    fill: "#27ABB3",
    stroke: "#27ABB3",
    strokeWidth: 2.77953
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackEmoji1);
export default __webpack_public_path__ + "static/media/Feedback_emoji_1.266ac30118859a539e4838888a3371f0.svg";
export { ForwardRef as ReactComponent };